import * as url from "../url_helper";

import { post } from "../api_helper";

export const addInquiry = data => post(url.ADD_INQUIRY, data);

export const addBulkProduct = data => post(url.ADD_BULK_PRODUCT, data);

export const getInquiryList = data => post(url.GET_INQUIRY_LIST, data);

export const getDealerInquiryList = data => post(url.GET_DEALER_INQUIRY_LIST, data);

export const getInquiryInfomation = data => post(url.GET_INQUIRY_INFO, data);


export const updateInquiry = data => post(url.UPDATE_INQUIRY, data);

export const uploadInquiryFile = file => {
    const formData = new FormData()
    formData.append("files", file)
    return post(url.UPLOAD_INQUIRY_FILE, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
}

export const getProductInquiryCount = data => post(url.GET_PRODUCT_INQUIRY_COUNT, data);
export const addNonRegisterDealer = data => post(url.ADD_NON_REGISTER_DEALER_INQUIRY, data, { skipInterceptor: true });

export const getNonRegisterDealer = data => post(url.GET_NON_REGISTER_DEALER_INQUIRY, data);
export const getOneNonRegisterDealer = data => post(url.GET_ONE_NON_REGISTER_DEALER_INQUIRY, data);

export const addInquiryRemarks = data => post(url.ADD_INQUIRY_REMARKS, data);

export const updateProductInquiryStatus = data => post(url.UPDATE_PRODUCT_INQUIRY_STATUS, data);
export const updateNonDealerProductInquiryStatus = data => post(url.UPDATE_NON_DEALER_PRODUCT_INQUIRY_STATUS, data);
export const addNonDealerInquiryRemarks = data => post(url.ADD_NON_DEALER_INQUIRY_REMARKS, data);


//------------------------------------------Query----------------------------------------------------//

export const getCustomerQueryList = data => post(url.GET_CUSTOMER_QUERY_LIST, data);
export const addQuery = data => post(url.ADD_QUERY, data);

export const uploadQueryFile = file => {
    const formData = new FormData()
    formData.append("files", file)
    return post(url.UPLOAD_QUERY_FILE, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
}

export const getQueryInfomation = data => post(url.GET_QUERY_INFO, data);
export const addQueryRemarks = data => post(url.ADD_QUERY_REMARKS, data);
export const updateProductQueryStatus = data => post(url.UPDATE_PRODUCT_QUERY_STATUS, data);
